<template>
	<div class="yw-select-box">
		<div v-for="item in data" :key="item.id">
			<!-- 多级 -->
			<div
				v-if="item.children && item.children.length"
				:class="itemClasses(item)"
				@click="handlePush(item)"
			>
				<i-checkbox
					v-model="item.check"
					:disabled="disabled || item.disabled"
					:indeterminate="itemIndeterminate(item)"
					:label="item.value"
				/>
				<a-icon type="right" class="yw-check-arrow" />
				<span
					class="yw-item-checkbox yw-cataract"
					@click="selectItem(item)"
				></span>
			</div>
			<!-- 单级 -->
			<i-checkbox
				v-else
				class="yw-check-item"
				v-model="item.check"
				:label="item.value"
				:disabled="disabled || item.disabled"
			/>
		</div>
	</div>
</template>
<script>
import ICheckbox from "./cusCheckbox.vue";
// 1.2 全选、单选计算
const computeChild = (list, Vue) => {
	list.forEach((item) => {
		if (item.children && item.children.length) {
			const child = item.children;
			if (child.every((ret) => ret.check)) Vue.$set(item, "check", true);
			else Vue.$set(item, "check", false);
			child && computeChild(child, Vue);
		} else {
			Vue.$set(item, "check", item.check || false);
		}
	});
};
export default {
	name: "selectBox",
	components: { ICheckbox },
	props: {
		value: {
			type: [String, Number],
		},
		data: {
			type: Array,
		},
		level: {
			type: Number,
		},
		disabled: {
			type: Boolean,
		},
		indeterminate: {
			type: Boolean,
		},
	},
	computed: {
		// 激活
		itemClasses() {
			return (item) => {
				const cls = ["yw-check-item"];
				item.id === this.value && cls.push("active");
				return cls;
			};
		},
	},
	methods: {
		selectAll() {
			if (this.disabled) return;
			this.$emit("on-select", {
				check: !this.all,
				level: this.level,
			});
		},
		// 多级全选
		selectItem(item) {
			if (this.disabled || item.disabled) return;
			this.$emit("on-select", {
				check: !item.check,
				level: this.level,
				cat: item.id,
			});
		},
		// checkbox 半选状态
		itemIndeterminate(child) {
			const hasChild = (meta) => {
				return meta.children.reduce((sum, item) => {
					let foundChilds = [];
					if (item.check) sum.push(item);
					if (item.children) foundChilds = hasChild(item);
					return sum.concat(foundChilds);
				}, []);
			};
			const some = hasChild(child).length > 0;
			const every = child.children && child.children.every((ret) => ret.check);
			return some && !every;
		},
		// push操作
		handlePush(item) {
			!(this.disabled || item.disabled) &&
				this.$emit("on-child", { item, level: this.level });
		},
	},
	watch: {
		// 1. changedata
		data: {
			handler(nVal, oVal) {
				computeChild(nVal, this);
			},
			deep: true,
		},
	},
	mounted() {
		computeChild(this.data, this);
	},
};
</script>
<style lang="less" scoped>
.yw-cataract {
	display: block;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 8;
	cursor: pointer;
}
.yw-check-item {
	margin: 0;
	padding: 0 12px;
	display: flex;
	position: relative;
	height: 36px;
	line-height: 36px;
	// overflow: hidden;
	// min-width: 120px;
	// max-width: 150px;
	&:hover {
		background-color: #f8f8f8;
	}
	&.active {
		color: #598fe6;
		background-color: rgba(230, 246, 255, 0.85);
		opacity: 0.8;
		.yw-check-arrow {
			color: #598fe6 !important;
		}
	}
	.yw-check-arrow {
		float: right;
		margin-top: 10px;
		color: #c1c1c1;
		// font-size: 12px;
	}
	.yw-item-checkbox {
		width: 36px;
		height: 36px;
	}
}
.ant-checkbox-wrapper {
	display: flex;
	align-items: center;
	overflow: hidden;
	flex: 1;
	:deep(span:nth-child(2)) {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: break-all;
		white-space: nowrap;
	}
}
</style>
